import React from "react";
import { FormattedMessage } from "react-intl";
import { CustomSelect, OptionItem } from "../../form/CustomSelect";
import { Icon } from "../../graphic/Icon";
import { Text } from "../../typography/Text";

const msgKey = "resourceActionTypeSelect";

export const APPROVAL_REQUEST = "APPROVAL_REQUEST";
export const CHANGE_REQUEST = "CHANGE_REQUEST";
export const COMMENT = "COMMENT";
export const ACKNOWLEDGEMENT_REQUEST = "ACKNOWLEDGEMENT_REQUEST";
export const SIGN_OFF = "SIGN_OFF";

const Description = ({ id }) => (
    <Text block size="small" color="base60">
        <FormattedMessage id={id} />
    </Text>
);

// eligibility: optional object from the eligibility endpoint (GET /resource-actions/eligibility)
// with boolean flags keyed by capability — { comment, acknowledge, acknowledgementRequest,
// approvalRequest, changeRequest }. A type is shown when its flag is true; when the prop is
// omitted or null, all types are shown. SIGN_OFF maps to the "acknowledge" flag.
const TYPE_TO_ELIGIBILITY = {
    [SIGN_OFF]: "acknowledge",
    [APPROVAL_REQUEST]: "approvalRequest",
    [CHANGE_REQUEST]: "changeRequest",
    [COMMENT]: "comment",
    [ACKNOWLEDGEMENT_REQUEST]: "acknowledgementRequest"
};

export const ResourceActionTypeSelect = ({ value, onChange, eligibility }) => {
    const isAllowed = (type) => !eligibility || !!eligibility[TYPE_TO_ELIGIBILITY[type]];

    return (
        <CustomSelect
            value={value}
            onChange={onChange}
            isClearable={false}
            placeholder={<FormattedMessage id={`${msgKey}.placeholder`} />}
        >
            {isAllowed(SIGN_OFF) ? (
                <OptionItem
                    value={SIGN_OFF}
                    symbol={<Icon name="check-circle" color="primary" />}
                    label={<FormattedMessage id={`${msgKey}.typeSignOff`} />}
                    description={<Description id={`${msgKey}.typeSignOffDescription`} />}
                />
            ) : null}
            {isAllowed(APPROVAL_REQUEST) ? (
                <OptionItem
                    value={APPROVAL_REQUEST}
                    symbol={<Icon name="thumbs-up" color="primary" />}
                    label={<FormattedMessage id={`${msgKey}.typeApprovalRequest`} />}
                    description={<Description id={`${msgKey}.typeApprovalRequestDescription`} />}
                />
            ) : null}
            {isAllowed(CHANGE_REQUEST) ? (
                <OptionItem
                    value={CHANGE_REQUEST}
                    symbol={<Icon name="edit" color="primary" />}
                    label={<FormattedMessage id={`${msgKey}.typeChangeRequest`} />}
                    description={<Description id={`${msgKey}.typeChangeRequestDescription`} />}
                />
            ) : null}
            {isAllowed(COMMENT) ? (
                <OptionItem
                    value={COMMENT}
                    symbol={<Icon name="comment-text" color="primary" />}
                    label={<FormattedMessage id={`${msgKey}.typeComment`} />}
                    description={<Description id={`${msgKey}.typeCommentDescription`} />}
                />
            ) : null}
            {isAllowed(ACKNOWLEDGEMENT_REQUEST) ? (
                <OptionItem
                    value={ACKNOWLEDGEMENT_REQUEST}
                    symbol={<Icon name="eye" color="primary" />}
                    label={<FormattedMessage id={`${msgKey}.typeAcknowledgementRequest`} />}
                    description={<Description id={`${msgKey}.typeAcknowledgementRequestDescription`} />}
                />
            ) : null}
        </CustomSelect>
    );
};
